import React, {useState, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import Loader from "react-loader-spinner";
import * as formActions from '../../Redux/Actions/form';
import Header from '../Ui/Header';
import DropDown from '../Ui/DropDown';
import {Button} from '../Ui/Button';
import {toastMessage} from '../utils/toast';
import Warning from '../Ui/400';
import { clearSession } from '../utils/initiate';
import {ContainerOuter, LoaderContainer, ContainerInner, Title} from './styles';
import AamerLoader from '../Ui/Loader';

const FormMapping = ({history}) => {

    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [departmentsList, setDepartmentsList] = useState([]);
    const [formsList, setFormsList] = useState([]);
    const [masterProcessList, setMasterProcessList] = useState([]);
    const [processList, setProcessList] = useState([]);
    const [departmentId, setDepartmentID] = useState('');
    const [masterProcessId, setMasterProcessID] = useState('');
    const [processId, setProcessID] = useState('');
    const [formId, setFormID] = useState('');
    const [errStatus, setErrStatus] = useState(200);
    const dispatch = useDispatch();

    useEffect(() => {
        setLoading(true);
        formActions.getAllServices().then(res => {
            if(res && res.data){
                let departmentsList = res.data.departments;
                departmentsList = departmentsList.map(({name, id, masterProcess}) => ({"label": name, "value": id, "masterProcess": masterProcess}));
                setLoading(false);
                setDepartmentsList(departmentsList);
            }else{
                toastMessage('error', 'Unable to load the process');
            }
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });

        formActions.getAllForms().then(res => {
            let formsList = [];
            res.data && res.data.map(({name, id}) => formsList.push({"label": name, "value": id}));
            setFormsList(formsList);
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleList = (key, ID) => {
        let list = [];
        if(key === 'department'){
            list = departmentsList.filter(({value}) => value === ID)[0].masterProcess;
            list = list.map(({name, id, process}) => ({"label": name, "value": id, "process": process}));
            setMasterProcessList(list);
        }else{
            list = masterProcessList.filter(({value}) => value === ID)[0].process;
            list = list.map(({name, id}) => ({"label": name, "value": id}));
            setProcessList(list);
        }
    }

    const handleFormMapping = () => {
        setButtonLoading(true);
        if((departmentId && departmentId.value) && (masterProcessId && masterProcessId.value) && (processId && processId.value) && (formId && formId.value)){
            let payload = {
                processId: processId.value, formId: formId.value
            };
            formActions.formMapping(payload).then(res => {
                if(res && res.data){
                    setDepartmentID(null); setMasterProcessID(null); setProcessID(null); setFormID(null);
                    toastMessage('success', 'Form mapped successfully');
                }else{
                    toastMessage('error', 'Unable to map the form');
                }
                setButtonLoading(false);
            });
        }else{
            setButtonLoading(false);
            toastMessage('error', 'Select the correct fields');
        }
    }

    if(errStatus === 400){
        return <Warning history={history} />;
    }

    return(
        <>
            <Header history={history} />
            <ContainerOuter>
                {loading && <LoaderContainer><AamerLoader /></LoaderContainer>}
                <ContainerInner>
                    <Title>Form Mapping</Title>
                    <DropDown label={'Department'} value={departmentId ? departmentsList[departmentId] : null} options={departmentsList} placeholder={'Select Department'} onChange={value => {setDepartmentID(value); setMasterProcessID(null); setProcessID(null); setProcessList([]); handleList('department', value.value)}} />
                    <DropDown label={'Master Process'} value={masterProcessId ? masterProcessList[masterProcessId] : null} options={masterProcessList} placeholder={'Select Master Process'} onChange={value => {setMasterProcessID(value); setProcessID(null); handleList('masterProcess', value.value)}} />
                    <DropDown label={'Process'} value={processId ? processList[processId] : null} options={processList} placeholder={'Select Process'} onChange={value => setProcessID(value)} />
                    <DropDown label={'Form'} value={formId ? formsList[formId] : null} options={formsList} placeholder={'Select Form'} onChange={value => setFormID(value)} />
                    <Button style={{display: 'block', margin: '30px auto'}} className="d-flex" onClick={handleFormMapping}>
                        Map {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                    </Button>
                </ContainerInner>
            </ContainerOuter>
        </>
    )
};

export default FormMapping;